import React from 'react';
export function WhatsAppIcon({
  className = 'w-[18px] h-[18px]'
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-142" data-mp="2joy3onz53a6i">
      <path d="M17.5 14.4c-.3-.2-1.7-.9-2-1-.3-.1-.5-.1-.6.2s-.7.9-.9 1.1c-.2.2-.3.2-.6.1s-1.3-.5-2.4-1.5c-.9-.8-1.5-1.8-1.6-2.1s0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5s0-.4 0-.5l-.9-2.1c-.2-.5-.4-.5-.6-.5h-.5c-.2 0-.5.1-.7.4-.3.3-1 1-1 2.4s1 2.8 1.2 3 2 3.1 4.9 4.3c2.4 1 2.9.8 3.4.8.5 0 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4 0-.1-.2-.2-.5-.3ZM12 2.1c5.5 0 9.9 4.4 9.9 9.9 0 5.5-4.4 9.9-9.9 9.9-1.7 0-3.4-.4-4.8-1.2L2 22.1l1.5-4.9A9.8 9.8 0 0 1 2.1 12c0-5.5 4.4-9.9 9.9-9.9Z" data-id="element-143" data-mp="25pg9ft32r4pr" />
    </svg>;
}